import { Component, OnInit } from '@angular/core';
import { QrCartService } from 'src/app/core/qr-cart/qr-cart.service';
import { Subscription } from 'rxjs';
import { CommonService } from '../../services/common.service';
import { QrScannerService } from 'src/app/core/services/qr-scanner.service';

@Component({
  selector: 'app-invalid-qr',
  templateUrl: './invalid-qr.component.html',
  styleUrls: ['./invalid-qr.component.scss']
})
export class InvalidQrComponent implements OnInit {

  otpInfo$: Subscription;
  locDesc: string = "";
  storeImageUrl: string = "assets/generalImage/qr_expired.svg"

  constructor(
    private qrCartService: QrCartService,
    private commonService: CommonService,
    private qrScannerService: QrScannerService
  ) { }

  ngOnInit(): void {
    this.otpInfo$ = this.commonService.getExpiredQrErrorData().subscribe((dt: any) => {
      this.locDesc = dt && dt.locDesc ? dt.locDesc : this.locDesc;
      this.storeImageUrl = dt && dt.storeImageUrl ? dt.storeImageUrl : this.storeImageUrl;
    })

    // everytime navigate to invalid qr, it will hide the countdown
    this.qrCartService.displayQrExpiryDate$.next(false);
  }

  onClickScan() {
    this.qrScannerService.show(false);
  }

  ngOnDestroy() {
    this.otpInfo$?.unsubscribe();
  }
}
